// eslint-disable-next-line
import $ from 'expose-loader?exposes=$,jQuery!jquery';
import 'url-search-params-polyfill';
import 'nodelist-foreach-polyfill';
import createMyPresent from "./createMyPresent";
import loginpage from "./loginpage";
import './heights';
import './steps';

window.loginpage = loginpage;
window.createMyPresent = createMyPresent;
